import {remote} from '../constants/environment';
import {defaultHeaders} from './headers';
import {IReceivable} from '../interfaces/dtos';
import {IReceivableListResponse} from '../interfaces/services';
import {customFetch as fetch, remoteCall} from '../utils/services';

export const getSalesmanReceivablesByDebtor = async (
  token: string,
  key: string,
  rif: string,
): Promise<IReceivableListResponse> => {
  const remoteURI = remote.getSalesmanReceivablesByDebtorUri(key, rif);

  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'GET',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
      });
    },
    async (response: Response) => {
      if (response.status === 200) {
        const data = await response.json();

        if (data.success && data.payload) {
          const success = true;
          return {
            success,
            payload: data.payload as IReceivable[],
          };
        } else {
          return {
            success: false,
            payload: null,
          };
        }
      }
    },
    remoteURI,
  )) as IReceivableListResponse;
};
